import {AbstractAsset} from './abstract-asset';
import {AssetKind} from './asset-kind.enum';

export class OtherAsset extends AbstractAsset {

    constructor() {
        super(AssetKind.OTHER);
    }
}
